import { syncRender } from 'globalCommon/services/syncRender';
import commonPageService from 'mCommon/services/commonPageService';
import { IUserInfo } from 'globalCommon/services/getUserInfo';
import './button.css';
import './style.css';

const dialogEduGlobal = require('globalCommon/html/dialogEduGlobal.html');

(window as any).showEduTutorial = function () {
    const dialog = document.createElement('div');
    dialog.innerHTML = dialogEduGlobal;
    dialog.classList.add('mobile');
    document.body.appendChild(dialog);
    dialog.querySelectorAll('.close-edu-global').forEach((element) => {
        (element as HTMLElement).onclick = () => {
            document.body.removeChild(dialog);
        };
    });
};

function init() {
    const cb = (userInfo: IUserInfo) => {
        const applyDesc = document.querySelector('.edu-apply-desc');
        applyDesc && (applyDesc.innerHTML = `Treten Sie dem UMU Education Development Program in nur zwei Schritten bei und genießen Sie Produkte der <span>Free Education Professional Edition</span>`);
        if (userInfo?.teacher_info?.teacher_status === 6) {
            const certificationBtn = document.querySelector('.btn-certification') as HTMLElement;
            certificationBtn && (certificationBtn.style.display = 'none');
        }
    };
    commonPageService({ cb, renderAfter: syncRender });
}

init();
